import { getAssessmentById } from '@/data/assessments'
import { AssessmentDetailPage } from './AssessmentDetailPage'

export function UCaaSAssessment() {
  const assessment = getAssessmentById('ucaas')!
  return <AssessmentDetailPage assessment={assessment} />
}
